import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import CloseIcon from '@mui/icons-material/Close';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import SaveAltIcon from '@mui/icons-material/SaveAlt';
import { Box, Button, ButtonBase, IconButton, Menu, MenuItem, Tooltip, useMediaQuery, useTheme } from '@mui/material';

import { Text } from '~/components/ui/text';
import { PREVIEW_BAR_VIEW_TYPE, TABLET_MIN_WIDTH } from '~/constants/common';
import { QR_CODE_TYPE } from '~/constants/qr-code';
import useBuilderStore from '~/store/useBuilderStore';
import { getEditQrLink } from '~/utils/qr-code';

import * as S from './styles';

export function QrItemButtons({ row, onDetail, onDownload, onDelete }) {
  const { t } = useTranslation();
  const theme = useTheme();
  const navigate = useNavigate();
  const isMobile = useMediaQuery(theme.breakpoints.down(TABLET_MIN_WIDTH));
  const [anchorEl, setAnchorEl] = useState(null);
  const [isMobileActionBar, setIsMobileActionBar] = useState(null);

  const isDynamicQr = row.type === QR_CODE_TYPE.DYNAMIC;

  const { setActiveStep, setPreviewViewType, previewViewType } = useBuilderStore();

  const handleEdit = () => {
    navigate(getEditQrLink(row));
    setActiveStep(1);
    if (previewViewType !== PREVIEW_BAR_VIEW_TYPE.PHONE) {
      setPreviewViewType(PREVIEW_BAR_VIEW_TYPE.PHONE);
    }
  };

  return (
    <Box sx={S.rigthWrapperButtons}>
      {isDynamicQr && !isMobile && (
        <Button variant="outlined" sx={S.detailBtn} size="small" onClick={onDetail}>
          {t('buttons:detail')}
        </Button>
      )}

      {!isMobile && (
        <Tooltip
          placement="top"
          slotProps={{
            tooltip: {
              sx: S.customTooltip,
            },
          }}
          title={t('buttons:download')}
        >
          <IconButton sx={S.ActionBtn} onClick={onDownload}>
            <SaveAltIcon />
          </IconButton>
        </Tooltip>
      )}
      <IconButton
        id={row?.id}
        aria-controls={anchorEl ? 'basic-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={anchorEl ? 'true' : undefined}
        sx={S.ActionBtn}
        onClick={(event) => {
          if (isMobile) {
            setIsMobileActionBar(row?.id);
          } else {
            setAnchorEl(event.currentTarget);
          }
        }}
      >
        <MoreVertIcon />
      </IconButton>
      {!isMobile ? (
        <Menu
          sx={S.ActionMenu}
          id={row?.id}
          anchorEl={anchorEl}
          open={Boolean(anchorEl && +anchorEl.id === row?.id)}
          onClose={() => setAnchorEl(null)}
        >
          <MenuItem onClick={handleEdit}>
            <Text variant="input15">{t('buttons:edit')}</Text>
          </MenuItem>
          <MenuItem onClick={onDelete}>
            <Text sx={{ color: 'var(--error)' }} variant="input15">
              {t('buttons:deleteQRcode')}
            </Text>
          </MenuItem>
        </Menu>
      ) : (
        <>
          {isMobileActionBar && <Box sx={S.MobileOverlay} onClick={() => setIsMobileActionBar(null)}></Box>}
          <Box className={isMobileActionBar === row?.id ? 'is-mobile-bar' : ''} sx={S.MobileActionBar}>
            <IconButton className="close-icon" onClick={() => setIsMobileActionBar(null)}>
              <CloseIcon />
            </IconButton>
            <Text sx={{ textTransform: 'capitalize', marginBottom: '16px' }} variant="h2">
              {t('labels:actions')}
            </Text>
            <ButtonBase sx={S.QrItemBtn} onClick={onDownload}>
              {t('buttons:download')}
            </ButtonBase>
            <ButtonBase sx={S.QrItemBtn} onClick={handleEdit}>
              {t('buttons:edit')}
            </ButtonBase>
            {isDynamicQr && (
              <ButtonBase sx={S.QrItemBtn} onClick={onDetail}>
                {t('buttons:detail')}
              </ButtonBase>
            )}
            <ButtonBase sx={S.QrItemBtn} className="is-delete" onClick={onDelete}>
              {t('buttons:delete')}
            </ButtonBase>
          </Box>
        </>
      )}
    </Box>
  );
}
